import { CALL_API, METHOD_TYPE } from '../../middleware/api.middleware'

/**
 * Custom Contact Action Type Constants
 * @type {string}
 */
export const GET_ORGANIZATIONS_REQUEST = 'GET_ORGANIZATIONS_REQUEST'
export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS'
export const GET_ORGANIZATIONS_FAILURE = 'GET_ORGANIZATIONS_FAILURE'

export const GET_CUSTOM_CONTACTS_REQUEST = 'GET_CUSTOM_CONTACTS_REQUEST'
export const GET_CUSTOM_CONTACTS_SUCCESS = 'GET_CUSTOM_CONTACTS_SUCCESS'
export const GET_CUSTOM_CONTACTS_FAILURE = 'GET_CUSTOM_CONTACTS_FAILURE'

/**
 * Get organizations that have custom contacts
 * @param params
 * @param options
 * @return {{}}
 * @private
 */
const _getOrganizations = (params, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      GET_ORGANIZATIONS_REQUEST,
      GET_ORGANIZATIONS_SUCCESS,
      GET_ORGANIZATIONS_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: '/contact/security',
    payload: params
  }
})

/**
 * Get custom contacts by organization id
 * @param id
 * @param params
 * @param options
 * @return {{}}
 * @private
 */
const _getContactsByOrganization = (id, params, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      GET_CUSTOM_CONTACTS_REQUEST,
      GET_CUSTOM_CONTACTS_SUCCESS,
      GET_CUSTOM_CONTACTS_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: `/contact/security/${id}`,
    payload: params
  }
})

/**
 * Dispatch GET_ORGANIZATIONS_REQUEST
 */
export const getOrganizations = (params, options) => (dispatch) => {
  return dispatch(_getOrganizations(params, options))
}

/**
 * Dispatch GET_CUSTOM_CONTACTS_REQUEST
 */
export const getContactsByOrganization = (id, options) => (dispatch) => {
  return dispatch(_getContactsByOrganization(id, options))
}
